/* ============================================================
   RF Utils V5 - helpers
============================================================ */

function pemrf_v5_qs(sel) {
  return document.querySelector(sel);
}

function pemrf_v5_qsa(sel) {
  return document.querySelectorAll(sel);
}

function pemrf_v5_createEl(tag, cls) {
  const el = document.createElement(tag);
  if (cls) el.className = cls;
  return el;
}

function pemrf_v5_shuffle(arr) {
  return arr
    .map(v => ({ sort: Math.random(), value: v }))
    .sort((a, b) => a.sort - b.sort)
    .map(o => o.value);
}

function pemrf_v5_getLangPack() {
  const root = pemrf_v5_qs("#pemrf-root-v5");
  const locale = root?.dataset?.locale || "hu";
  return window.PEM_LANG_V5?.[locale] || window.PEM_LANG_V5?.hu || {};
}